module.exports = __webpack_public_path__ + "static/media/icn-logout.c7721107.svg";